export const createSlug = (title) => {
  if (!title) return '';
  
  return title
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') 
    .replace(/\s+/g, '-')     
    .replace(/--+/g, '-')     
    .trim();                  
};

export const storeSlugToIdMapping = (slug, id) => {
  try {
    let mappings = JSON.parse(localStorage.getItem('blogSlugMappings') || '{}');
    mappings[slug] = id;
    localStorage.setItem('blogSlugMappings', JSON.stringify(mappings));
  } catch (error) {
    console.error('Error storing slug mapping:', error);
  }
};

export const getIdFromSlug = (slug) => {
  try {
    const mappings = JSON.parse(localStorage.getItem('blogSlugMappings') || '{}');
    return mappings[slug] || null;
  } catch (error) {
    console.error('Error retrieving slug mapping:', error);
    return null;
  }
}; 